// ----------------------------------------------------------------------
// Where the access token lives.
//
// Kept outside React so the axios interceptor can read it without a hook,
// and mirrored in localStorage so a reload keeps the session.
// ----------------------------------------------------------------------

const STORAGE_KEY = 'jobvictory.token';

let accessToken: string | null = readStoredToken();

function readStoredToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Private mode or blocked storage — the session just won't survive a reload.
    return null;
  }
}

export function getToken(): string | null {
  return accessToken;
}

export function setToken(token: string | null): void {
  accessToken = token;

  try {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* in-memory only */
  }
}

/** Called by the axios interceptor when the server rejects the token. */
let onUnauthorized: (() => void) | null = null;

export function setUnauthorizedHandler(handler: (() => void) | null): void {
  onUnauthorized = handler;
}

export function notifyUnauthorized(): void {
  onUnauthorized?.();
}
